const styles = (theme) => ({
  newGridContent: {
    padding: '0 30px 20px 30px',
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '0 20px 20px 20px'
    }
  },
  contentContainer: {
    width: '100%',
    paddingTop: theme.spacing(2)
  },
  headerSection: {
    marginBottom: theme.spacing(4)
  },
  titleContainer: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch'
    }
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary
  },
  key: {
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2)
  },
  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    maxWidth: '800px'
  },
  pillarsSection: {
    marginTop: theme.spacing(4)
  },
  pillarsLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.primary
  },
  pillarsStack: {
    width: '100%'
  },
  pillarCard: {
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
      boxShadow: theme.shadows[4]
    }
  },
  pillarTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main
  },
  pillarDescription: {
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(2)
  },
  pillarInfo: {
    display: 'flex',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap'
  },
  pillarInfoText: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem'
  },
  pillarInfoLabel: {
    fontWeight: 600
  },
  pillarInfoLink: {
    color: theme.palette.primary.main
  },
  pillarButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  configureRulesButton: {
    textTransform: 'none',
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    minWidth: 'auto',
    fontSize: '0.8125rem',
    height: '28px',
    '&.MuiButton-root': {
      borderRadius: 0
    }
  },
  tagContentButton: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.grey[200],
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    minWidth: 'auto',
    fontSize: '0.8125rem',
    height: '28px',
    '&.MuiButton-root': {
      borderRadius: 0
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    }
  },
  noPillars: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    padding: theme.spacing(2)
  },
  errorContainer: {
    padding: theme.spacing(3),
    textAlign: 'center'
  }
});

export default styles;

